/** The request path builder for querying for a customer for a set of known contact details. */
export const getCustomerSearchPath = (contactId: string, customerId: string) =>
  `Legacy/V2/contacts/${contactId}/customers/${customerId}`;

export const putContactResultPath = (contactId: string, contactResultId: string) =>
  `V1/contacts/${contactId}/result/${contactResultId}`;

export const postContactResultPath = (contactId: string) => `V1/contacts/${contactId}/result`;
